import React from 'react'
import Link, { withPrefix } from 'gatsby-link'
import styled from 'styled-components'
import Img from 'gatsby-image'

const Container = styled.div`
    border-bottom 1px solid rgba(255,255,255,.08);
    border-radius: 4px;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin: 2.5rem 0 5rem;
    overflow: hidden;
    p {
        margin-bottom: 1rem;
    }
    @media screen and (min-width: 800px) {
        & {
            flex-direction: row;
            align-items: flex-start;
        }
    }
    span {
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }
}
`

const Div = styled.div`
  flex: 1;
  margin-bottom: 5rem;
  @media screen and (min-width: 800px) {
    padding: 0 0 0 3rem;
  }
`

const Figure = styled.figure`
  background: #32f095;
  border-radius: 4px;
  margin: 0 0 1.5rem;
  position: relative;
  padding: 0;
  img {
    border-radius: 4px;
    mix-blend-mode: multiply;
    vertical-align: top;
    max-width: 120px;
    width: 100%;
  }
  @media screen and (min-width: 800px) {
    & {
      width: 200px;
    }
    img {
      max-width: 200px;
    }
  }
`

const Name = styled.h3`
  font-size: 2.5rem;
  font-weight: 300;
  margin: 0;
  @media screen and (min-width: 750px) {
    &::before {
      background: #32f095;
      content: '';
      display: block;
      height: 4px;
      margin-bottom: 2.5rem;
      width: 40px;
    }
  }
`

const Title = styled.p`
  font-weight: bold;
`

const TalkTitle = styled.h4`
  font-size: 2rem;
  font-weight: 300;
  margin: 0;
  &::before {
    background: rgba(255,255,255,.08);
    border-radius: 4px;
    content: 'Talk:';
    display: block;
    margin-bottom: 1.5rem;
    margin-top: 3.5rem;
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    line-height: 1;
    padding: 1rem;
  }
`

const Bio = styled.p``

const Talk = styled.p``

const Twitter = styled.a`
  margin-right: 1.5rem;
  display: block;
  @media screen and (min-width: 600px) {
    display: inline;
  }
`

const Website = styled.a`
  margin-right: 1rem;
  display: block;
  @media screen and (min-width: 600px) {
    display: inline;
  }
`

const Speaker = ({
  name,
  title,
  photo,
  photoTwo,
  bio,
  twitter,
  website,
  talkTitle,
  talkHTML,
  shortSlug,
}) => (
  <Container id={shortSlug}>
    <div>
      <Figure>
        <Img sizes={photo} alt={name} />
      </Figure>
      {photoTwo && (
        <Figure>
          <Img sizes={photoTwo} alt={name} />
        </Figure>
      )}
    </div>
    <Div>
      <Name>{name}</Name>
      <Title>{title}</Title>
      <Bio>{bio}</Bio>
      <p>
        <Twitter href={`https://twitter.com/${twitter}`}>{twitter}</Twitter>
        <Website href={website}>{website}</Website>
      </p>
      <TalkTitle>{talkTitle}</TalkTitle>
      <Talk dangerouslySetInnerHTML={{ __html: talkHTML }} />
    </Div>
  </Container>
)

export default Speaker



// WEBPACK FOOTER //
// ./src/components/speaker.js